export const filterInstitution = (institutions = []) =>
  institutions.filter(inst => inst.transferTopInstitution);
